import { Layout, Tabs, TabsProps } from 'antd';
import React, { useMemo, useState } from 'react';
import {
  CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1FieldsFragment,
  IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations,
  IdentityVerificationCaseV1CaseDetailsApplicationReviewInput,
  IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations
} from '../../../../../../generated';
import { AffirmationsChecklist, SharedCaseAffirmationsAudit } from '../../../../../shared/affirmations-checklist/affirmations-checklist';
import { ReviewDocumentsButtonContainer } from './review-documents-button-container';


export interface ChecklistProps {
  data: CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1FieldsFragment;
  isSuccess: boolean;
  onSave: (values: IdentityVerificationCaseV1CaseDetailsApplicationReviewInput) => Promise<void>;
}

export const IdCaseAffirmationsFieldNames = {
  ID_DOCUMENT_ACCEPTIBLE: 'ID Document Acceptable',
  ID_DOCUMENT_DETAILS_ACCEPTABLE: 'ID Document Details Acceptable',
  PHOTO_ACCEPTIBLE: 'Photo Acceptable',
  NOTARIZED_ID_ACCEPTIBLE: 'Notarized ID Acceptable',
  NOTARY_ACCEPTIBLE: 'Notary Acceptable'
};

export const Checklist: React.FC<ChecklistProps> = (props) => {
  const [activeTab, setActiveTab] = useState('1');

  const stripFieldsForAffirmations = (data: IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations) => {
    if (!data) {
      return {
        isIdDocumentAcceptable: null,
        isIdDocumentDetailsAcceptable: null,
        isPhotoAcceptable: null
      };
    }
    const { audit, __typename, ...rest } = data;
    return rest;
  };

  const stripFieldsForNotaryAffirmations = (data: IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations) => {
    if (!data) {
      return {
        isNotarizedIdAcceptable: null,
        isNotaryAcceptable: null
      };
    }
    const { audit, __typename, ...rest } = data;
    return rest;
  };

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  const fieldNamesMap = useMemo(
    () =>
      new Map<string, string>([
        ['isIdDocumentAcceptable', IdCaseAffirmationsFieldNames.ID_DOCUMENT_ACCEPTIBLE],
        ['isIdDocumentDetailsAcceptable', IdCaseAffirmationsFieldNames.ID_DOCUMENT_DETAILS_ACCEPTABLE],
        ['isPhotoAcceptable', IdCaseAffirmationsFieldNames.PHOTO_ACCEPTIBLE],
        ['isNotarizedIdAcceptable', IdCaseAffirmationsFieldNames.NOTARIZED_ID_ACCEPTIBLE],
        ['isNotaryAcceptable', IdCaseAffirmationsFieldNames.NOTARY_ACCEPTIBLE]
      ]),
    []
  );

  const tabItems: TabsProps['items'] = [
    {
      key: '1',
      label: 'Application',
      children: (
        <AffirmationsChecklist
          affirmations={
            stripFieldsForAffirmations(
              props.data?.caseDetails?.applicationReview?.affirmations as IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations
            ) as IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations
          }
          audit={props.data?.caseDetails?.applicationReview?.affirmations?.audit as SharedCaseAffirmationsAudit}
          fieldName="affirmations"
          onSave={props.onSave}
          fieldNamesMap={fieldNamesMap}
          state={props.data.state}
          disabled={!props.data.isCurrentUserAssigned || (props.data.state === 'revisionRequested' && props.data.isCurrentUserAssigned)}
          isSuccess={props.isSuccess}
        />
      )
    },
    {
      key: '2',
      label: 'Notary',
      children: (
        <AffirmationsChecklist
          affirmations={
            stripFieldsForNotaryAffirmations(
              props.data?.caseDetails?.applicationReview?.notaryAffirmations as IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations
            ) as IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations
          }
          audit={props.data?.caseDetails?.applicationReview?.notaryAffirmations?.audit as SharedCaseAffirmationsAudit}
          fieldName="notaryAffirmations"
          onSave={props.onSave}
          fieldNamesMap={fieldNamesMap}
          state={props.data.state}
          disabled={
            !props.data.isCurrentUserAssigned ||
            props.data.state === 'draft' ||
            props.data.state === 'decisionRendered' ||
            (props.data.state === 'revisionRequested' && props.data.isCurrentUserAssigned)
          }
          isSuccess={props.isSuccess}
        />
      )
    }
  ];
  return (
    <Layout
      style={{
        borderRadius: '10px'
      }}
    >
      <ReviewDocumentsButtonContainer caseId={props.data.id} />
      <Tabs defaultActiveKey="1" items={tabItems} activeKey={activeTab} onChange={handleTabChange} />
    </Layout>
  );
};
